<template>
  <CCard>
    <CCardHeader>
      <h2>{{ searchMode ? '所属プロジェクト詳細' : 'プロジェクト詳細' }}</h2>
    </CCardHeader>
    <CCardBody>
      <CAlert v-if="searchMode" color="info">
        現在所属しているプロジェクトの参照画面です。登録・更新・削除はプロジェクト管理権限を持つ担当者が行います。
      </CAlert>
      <CAlert v-if="errorMessage" color="danger">{{ errorMessage }}</CAlert>
      <div v-if="loading" class="d-flex align-items-center py-4">
        <CSpinner color="primary" class="mr-2"/>
        <span>プロジェクト情報を読み込んでいます。</span>
      </div>
      <template v-else-if="items">
        <CRow>
          <CCol sm="6">
            <table class="table">
              <tr><th>顧客会社名</th><td>{{ items.company_name }}</td></tr>
              <tr><th>プロジェクト名</th><td>{{ items.name }}</td></tr>
              <tr><th>自社管理者</th><td>{{ items.private_staff_name }}</td></tr>
              <tr><th>顧客会社担当者</th><td>{{ items.staff_name }}</td></tr>
              <tr><th>関連会社</th><td>{{ items.related }}</td></tr>
              <tr><th>その他関連</th><td>{{ items.other_related }}</td></tr>
              <tr><th>始業時刻</th><td>{{ items.start_time }}</td></tr>
              <tr><th>終了時刻</th><td>{{ items.end_time }}</td></tr>
              <tr><th>休憩開始時間</th><td>{{ items.break_start_time }}</td></tr>
              <tr><th>休憩終了時間</th><td>{{ items.break_end_time }}</td></tr>
              <tr><th>基準時間(表示用)</th><td>{{ items.base_time }}</td></tr>
              <tr><th>基準時間(下限)</th><td>{{ items.base_time_min }}</td></tr>
              <tr><th>基準時間(上限)</th><td>{{ items.base_time_max }}</td></tr>
              <tr><th>契約形態</th><td>{{ items.contract }}</td></tr>
              <tr><th>その他契約事項</th><td>{{ items.other_contract }}</td></tr>
              <tr><th>開発言語</th><td>{{ items.language }}</td></tr>
              <tr><th>その他必要技術</th><td>{{ items.other_tech }}</td></tr>
            </table>
          </CCol>
        </CRow>
        <CRow class="mt-3 align-items-center">
          <CCol class="text-start">
            <button
              v-if="searchMode"
              type="button"
              class="btn btn-secondary"
              @click="goBack"
            >
              戻る
            </button>
            <router-link v-else :to="{ name: projectList }">
              <button type="button" class="btn btn-secondary">戻る</button>
            </router-link>
          </CCol>
          <CCol class="text-center">
            <router-link v-if="!searchMode" :to="editRoute">
              <button type="button" class="btn btn-info">編集</button>
            </router-link>
          </CCol>
          <CCol></CCol>
        </CRow>
      </template>
    </CCardBody>
  </CCard>
</template>

<script>
import axios from 'axios'
import ConstList from './../ConstList'
import { recordQueryRoute, resolveRouteRecordId } from '@/common/routeRecordId'
import { safeErrorDigest } from '../utils/safeResponseMessage'

export default {
  name: 'ProjectInfo',
  data () {
    return {
      items: null,
      projectId: null,
      projectList: ConstList.ROUTE_PROJECT_LIST,
      projectUpdate: ConstList.ROUTE_PROJECT_UPDATE,
      loading: false,
      errorMessage: ''
    }
  },
  computed: {
    searchMode () {
      return this.$route.name === 'プロジェクト検索詳細' ||
        String(this.$route.path || '').startsWith('/project/search/')
    },
    editRoute () {
      return this.projectId
        ? recordQueryRoute(this.projectUpdate, this.projectId)
        : { name: this.projectList }
    }
  },
  watch: {
    '$route.fullPath': 'loadProject'
  },
  mounted () {
    this.loadProject()
  },
  methods: {
    async loadProject () {
      this.errorMessage = ''
      this.items = null
      this.projectId = resolveRouteRecordId(this.$route)
      if (!this.projectId) {
        this.errorMessage = 'プロジェクトを特定できません。選択し直してください。'
        return
      }

      this.loading = true
      try {
        const endpoint = this.searchMode
          ? `/management/projects/${this.projectId}`
          : `/project/${this.projectId}`
        const response = await axios.get(
          `${process.env.VUE_APP_API_ORIGIN}${endpoint}`
        )
        this.items = response.data || null
        if (!this.items) this.errorMessage = 'プロジェクトが見つかりません。'
      } catch (error) {
        const status = error && error.response ? Number(error.response.status) : 0
        if (status === 403) {
          this.errorMessage = this.searchMode
            ? '現在所属しているプロジェクトだけ参照できます。'
            : 'プロジェクト管理権限がありません。'
        } else if (status === 404) {
          this.errorMessage = '表示可能なプロジェクトが見つかりません。'
        } else {
          this.errorMessage = 'プロジェクト情報を取得できませんでした。'
        }
        console.error('プロジェクト詳細取得失敗:', safeErrorDigest(error))
      } finally {
        this.loading = false
      }
    },
    goBack () {
      if (typeof window !== 'undefined' && window.history.length > 1) {
        this.$router.go(-1)
        return
      }
      this.$router.push('/dashboard').catch(() => {})
    }
  }
}
</script>

<style scoped>
td {
  word-break: break-all;
}
</style>
